/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactroutinglettertitle3Inputs */

const en_artifactroutinglettertitle3 = /** @type {(inputs: Artifactroutinglettertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routing recommendation`)
};

const pt_artifactroutinglettertitle3 = /** @type {(inputs: Artifactroutinglettertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendação de encaminhamento`)
};

/**
* | output |
* | --- |
* | "Routing recommendation" |
*
* @param {Artifactroutinglettertitle3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactroutinglettertitle3 = /** @type {((inputs?: Artifactroutinglettertitle3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactroutinglettertitle3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactroutinglettertitle3(inputs)
	return pt_artifactroutinglettertitle3(inputs)
});
export { artifactroutinglettertitle3 as "artifactRoutingLetterTitle" }